import React from "react";
import styles from "./SlideItem.module.css";

// 배경 이미지들만 import
import bg1 from "../../../assets/bg_1.webp";
import bg2 from "../../../assets/bg_2.webp";
import bg3 from "../../../assets/bg_3.webp";
import bg4 from "../../../assets/bg_4.webp";

const backgroundImageMap = {
  "bg_1.webp": bg1,
  "bg_2.webp": bg2,
  "bg_3.webp": bg3,
  "bg_4.webp": bg4,
};

const SlideItem = ({ slide, isActive, isVisible }) => {
  const slideClass = `
    ${styles.slideItem}
    ${isActive ? styles.active : ""}
    ${isVisible ? styles.visible : ""}
  `.trim();

  const backgroundImage = backgroundImageMap[slide.background];

  return (
    <div className={slideClass}>
      {/* 배경 이미지만 */}
      <div
        className={styles.background}
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      />

      {/* 오버레이 */}
      <div className={styles.overlay} />
    </div>
  );
};

export default SlideItem;
